import { render, staticRenderFns } from "./rightBar.vue?vue&type=template&id=ded4e892"
import script from "./rightBar.vue?vue&type=script&lang=js"
export * from "./rightBar.vue?vue&type=script&lang=js"
import style0 from "./rightBar.vue?vue&type=style&index=0&id=ded4e892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports